'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useEffect } from 'react';
import { metaQueries } from '@/entities/meta';
import { queryClient, useApiErrorHandler } from '@/shared/api';
import { clearGlobalErrorHandler, setGlobalErrorHandler } from '@/shared/api';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
export default function QueryProvider(t0) {
  const $ = _c(7);
  const {
    children
  } = t0;
  const handleApiError = useApiErrorHandler();
  let t1;
  let t2;
  if ($[0] !== handleApiError) {
    t1 = () => {
      setGlobalErrorHandler(handleApiError);
      return _temp;
    };
    t2 = [handleApiError];
    $[0] = handleApiError;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  useEffect(_temp2, t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ReactQueryDevtools initialIsOpen={false} />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== children) {
    t5 = <QueryClientProvider client={queryClient}>{children}{t4}</QueryClientProvider>;
    $[5] = children;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}
function _temp2() {
  queryClient.prefetchQuery({
    ...metaQueries.get()
  });
}
function _temp() {
  return clearGlobalErrorHandler();
}